import lang from "src/assets/lang.json";
import iso from "src/assets/iso.json";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { Router } from "@angular/router";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { ListProductItem } from "src/app/core/services/outbound";
import {
  user_role_color_map,
  user_role_map,
  user_search_placeholder_map,
  user_status_color_map,
  user_status_map,
} from "src/app/core/services/constants";

@Component({
  selector: "app-products-selector",
  templateUrl: "./products-selector.component.html",
  styleUrls: ["./products-selector.component.scss"],
  providers: [],
})

/**
 * Contacts domain-list component
 */
export class ProductsSelectorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() mode = "list";
  @Input() vendorID;
  @Input() single = false;
  @Input() selectedProducts = [];
  @Input() className: string[];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  // bread crumb items
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 24;
  currentPage = 0;
  productList: {};
  productListSubscription: any;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  status_map = {};
  status_color_map = {};
  user_search_placeholder_map = {};
  user_role_map = {};
  user_role_color_map = {};
  payload = {};
  productListForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  countries = [];
  loading = false;
  verifySubscription: any;
  my_id: any;

  selectedProductsList = {};

  constructor(
    private ws: WebsocketService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // console.log(this.router.url);
    this.countries = iso.map((a) => a.name);
    this.status_map = user_status_map;
    this.status_color_map = user_status_color_map;
    this.user_role_map = user_role_map;
    this.user_role_color_map = user_role_color_map;
    this.user_search_placeholder_map = user_search_placeholder_map;

    // console.log(this.countries);
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.productList = {};
    // console.log(Object.keys(this.userList).length);

    this.productListForm = this.formBuilder.group({
      chat_id: new UntypedFormControl(null),
      created_date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
      search_value: new UntypedFormControl(null),
      status: new UntypedFormControl(""),
      category: new UntypedFormControl(""),
    });

    this.productListSubscription = this.ws.listProductContainer$.subscribe(
      (listProductsData) => {
        if (listProductsData && listProductsData.ref === this.component_ref) {
          this.loading = false;
          this.currentPage = listProductsData.page_number;
          if (listProductsData.data.length == 0 && this.currentPage == 1) {
            this.search_message = "No results matched your search criteria";
          }

          listProductsData.data.forEach((product: any) => {
            product.created_date = new Date(product.created_date);
            product.created_date =
              product.created_date.getDate() +
              " " +
              this.monthNames[product.created_date.getMonth()] +
              ", " +
              product.created_date.getFullYear();
            // product.country_alpha = iso.find((e) => e.code == product.country_code)?.alpha;

            this.productList[String(product.id)] = product;
          });
          // console.log(Object.keys(this.userList).length);

          this.page = [];
          for (let i = 0; i < this.pageSize; i++) {
            if (
              Object.keys(this.productList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ) {
              this.page.push(
                this.productList[
                  Object.keys(this.productList)[
                    i + (this.currentPage - 1) * this.pageSize
                  ]
                ]
              );
            }
          }

          document.getElementById("pagination_back").classList.remove("d-none");
          document
            .getElementById("pagination_back")
            .classList.add("enablePointer");
          document.getElementById("pagination_next").classList.remove("d-none");
          document
            .getElementById("pagination_next")
            .classList.add("enablePointer");

          this.eop = false;
          if (listProductsData.eop) {
            this.eop = true;
            document.getElementById("pagination_next").classList.add("d-none");
            document
              .getElementById("pagination_next")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_next")
              .classList.remove("d-none");
            document
              .getElementById("pagination_next")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1) {
            document.getElementById("pagination_back").classList.add("d-none");
            document
              .getElementById("pagination_back")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_back")
              .classList.remove("d-none");
            document
              .getElementById("pagination_back")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1 && listProductsData.eop) {
            document
              .getElementById("showPageNumber")
              .classList.add("invisible");
          } else {
            document
              .getElementById("showPageNumber")
              .classList.remove("invisible");
          }
          this.ref.detectChanges();
        }
      }
    );

    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          this.payload["category"] = this.className;
          if(this.vendorID){
            this.payload["vendor_id"] = this.vendorID;
          }
          this.my_id = this.mdw.getID();
          this.loading = true;
          this.ws.processMethod(
            new ListProductItem(
              0,
              localStorage.getItem("chat_id"),
              this.component_ref,
              this.payload["product_id"],
              this.payload["name"],
              this.payload["created_date"],
              this.payload["status"],
              this.payload["category"],
              this.payload["vendor_id"]
            )
          );
        }
      }
    );

    if (this.selectedProducts && this.selectedProducts.length > 0) {
      for (let i = 0; this.selectedProducts.length > i; i++) {
        this.selectedProductsList[this.selectedProducts[i].id] =
          this.selectedProducts[i];
      }
    }

    this.breadCrumbItems = [
      { label: "MENUITEMS.STOREMANGER.TEXT" },
      { label: "PRODUCTS.PRODUCTS", active: true },
    ];
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.productListSubscription) {
      this.productListSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    document.getElementById("pagination_back").classList.add("d-none");
    document
      .getElementById("pagination_back")
      .classList.remove("enablePointer");
    document.getElementById("pagination_next").classList.add("d-none");
    document
      .getElementById("pagination_next")
      .classList.remove("enablePointer");
  }

  openDetails(data: any) {
    this.router.navigate([
      "/" +
        data.account_id +
        "/" +
        data.ref_domain +
        "/" +
        data.service.product,
    ]);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.productListForm.controls;
  }

  onSubmit() {
    this.loading = true;

    let id =
      this.f.search_type.value === "product" ? this.f.search_value.value : null;
    let name =
      this.f.search_type.value === "name" ? this.f.search_value.value : null;
    let created_date = this.f.created_date.value;
    let status = this.f.status.value;
    let category = this.f.category.value;
    this.search(id, name, created_date, status, category);
  }

  search(id: any, name: any, created_date: any, status: any, category: any) {
    this.currentPage = 0;
    this.productList = {};
    this.payload = {};
    this.search_message = "";

    this.payload = {
      page_size: this.pageSize,
      page_number: 0,
      chat_id: localStorage.getItem("chat_id"),
    };

    if (id != null && id !== "") {
      this.payload["product_id"] = id;
    }
    if (name != null && name !== "") {
      this.payload["name"] = name;
    }
    if (created_date != null && created_date !== "") {
      this.payload["created_date"] = created_date;
    }
    if (status != null && status !== "") {
      this.payload["status"] = status;
    }

    if (category != null && category !== "") {
      this.payload["category"] = [category];
    } else {
      this.payload["category"] = this.className;
    }

    if (this.vendorID) {
      this.payload["vendor_id"] = this.vendorID;
    }

    this.ws.processMethod(
      new ListProductItem(
        0,
        localStorage.getItem("chat_id"),
        this.component_ref,
        this.payload["product_id"],
        this.payload["name"],
        this.payload["created_date"],
        this.payload["status"],
        this.payload["category"],
        this.payload["vendor_id"]
      )
    );
  }
  resetSearch() {
    this.currentPage = 0;
    this.productList = {};
    this.search_message = "";

    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");
    this.payload["category"] = this.className;
    if(this.vendorID){
            this.payload["vendor_id"] = this.vendorID;
          }

    this.ws.processMethod(
      new ListProductItem(
        this.currentPage,
        localStorage.getItem("chat_id"),
        this.component_ref,
        this.payload["product_id"],
        this.payload["name"],
        this.payload["created_date"],
        this.payload["status"],
        this.payload["category"],
        this.payload["vendor_id"]
      )
    );
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");
    if(this.vendorID){
            this.payload["vendor_id"] = this.vendorID;
          }

    this.ws.processMethod(
      new ListProductItem(
        this.currentPage,
        localStorage.getItem("chat_id"),
        this.component_ref,
        this.payload["product_id"],
        this.payload["name"],
        this.payload["created_date"],
        this.payload["status"],
        this.payload["category"],
        this.payload["vendor_id"]
      )
    );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.productList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.productList[
              Object.keys(this.productList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.productList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  selectProduct(data) {
    if (this.single) {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList = {};
        this.selectedProductsList[data.id] = data;
      }
    } else {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList[data.id] = data;
      }
    }
  }

  insertEvent() {
    const selected = Object.values(this.selectedProductsList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedProductsList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedProductsList[id] ? true : false;
  }
}
